import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';


export class ScrollToTop extends React.Component {
    componentDidUpdate(prevProps) {
        const { location } = this.props;

        if (location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        const { doScroll, children } = this.props;

        if (doScroll) {
            window.scrollTo(0, 0);
        }
        return children;
    }
}

ScrollToTop.defaultProps = {
    location: null,
    doScroll: false
};

ScrollToTop.propTypes = {
    
    location: PropTypes.object,
    
    children: PropTypes.node.isRequired,
    doScroll: PropTypes.bool
};

export default withRouter(ScrollToTop);
